import React, { useEffect, useState } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import MobileActionMenu from "../../components/MobileActionMenu";
import {
  Box,
  Typography,
  TextField,
  Button,
  IconButton,
  FormControl,
  FormControlLabel,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Chip,
  Tooltip,
  InputAdornment,
  CircularProgress,
  Grid,
  Switch,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Checkbox,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import VisibilityIcon from "@material-ui/icons/Visibility";
import CloseIcon from "@material-ui/icons/Close";
import AddIcon from "@material-ui/icons/Add";
import SearchIcon from "@material-ui/icons/Search";
import ShoppingBasketIcon from "@material-ui/icons/ShoppingBasket";
import CategoryIcon from "@material-ui/icons/Category";
import BallotIcon from "@material-ui/icons/Ballot";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import api from "../../services/api";
import { useSystemAlert } from "../../components/SystemAlert";
import toastError from "../../errors/toastError";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { usePlanPermissions } from "../../context/PlanPermissionsContext";
import CatalogoPublicoBotao from "../../components/CatalogoPublicoBotao";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    backgroundColor: "transparent",
    overflowY: "auto",
    ...theme.scrollbarStyles,
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "16px 24px",
    borderBottom: "1px solid #e0e0e0",
    flexWrap: "wrap",
    gap: 12,
    [theme.breakpoints.down("sm")]: { padding: "12px 16px", flexDirection: "column", alignItems: "stretch" },
  },
  headerLeft: {
    display: "flex",
    alignItems: "center",
    gap: 16,
  },
  headerTitle: {
    fontSize: "1.5rem",
    fontWeight: 600,
    color: "#1a1a1a",
    [theme.breakpoints.down("sm")]: { fontSize: "1.2rem" },
  },
  headerSubtitle: {
    fontSize: "0.875rem",
    color: "#666",
  },
  headerRight: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    flexWrap: "wrap",
    [theme.breakpoints.down("sm")]: { flexDirection: "column", alignItems: "stretch" },
  },
  searchField: {
    backgroundColor: "#fff",
    borderRadius: 8,
    minWidth: 220,
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
      "& fieldset": { borderColor: "#e0e0e0" },
      "&:hover fieldset": { borderColor: "#1976d2" },
    },
    [theme.breakpoints.down("sm")]: { minWidth: "unset", width: "100%" },
  },
  filterSelect: {
    minWidth: 150,
    backgroundColor: "#fff",
    "& .MuiOutlinedInput-root": { borderRadius: 8 },
    [theme.breakpoints.down("sm")]: { minWidth: "unset", width: "100%" },
  },
  addButton: {
    borderRadius: 8,
    padding: "6px 20px",
    textTransform: "none",
    fontWeight: 600,
    [theme.breakpoints.down("sm")]: { width: "100%" },
  },
  content: {
    padding: "16px 24px 24px",
    [theme.breakpoints.down("sm")]: { padding: "12px 12px 16px" },
  },
  tableWrapper: {
    backgroundColor: "#fff",
    borderRadius: 12,
    overflow: "hidden",
    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
  },
  tableScroll: {
    overflowX: "auto",
    width: "100%",
  },
  tableHead: {
    backgroundColor: "var(--primary-color, #1e293b)",
    "& th": {
      color: "#fff",
      fontWeight: 600,
      fontSize: "0.8rem",
      textTransform: "uppercase",
      letterSpacing: "0.05em",
      borderBottom: "none",
      padding: "14px 16px",
    },
  },
  tableBody: {
    "& td": {
      padding: "12px 16px",
      fontSize: "0.875rem",
      color: "#334155",
      borderBottom: "1px solid #f1f5f9",
    },
    "& tr:hover": {
      backgroundColor: "#f8fafc",
    },
  },
  paginationBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "12px 16px",
    borderTop: "1px solid #f1f5f9",
    backgroundColor: "#fff",
    borderRadius: "0 0 12px 12px",
    flexWrap: "wrap",
    gap: 8,
    [theme.breakpoints.down("sm")]: { padding: "8px 12px" },
  },
  actionBtn: {
    minWidth: "auto",
    padding: "4px 8px",
    borderRadius: 6,
    fontWeight: 600,
    fontSize: "0.8rem",
    textTransform: "none",
  },
  thumbImg: {
    width: 40,
    height: 40,
    borderRadius: 6,
    objectFit: "cover",
  },
  thumbPlaceholder: {
    width: 40,
    height: 40,
    borderRadius: 6,
    backgroundColor: "#f1f5f9",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& svg": { fontSize: 20, color: "#94a3b8" },
  },
  statusChip: {
    fontWeight: 600,
    fontSize: "0.75rem",
  },
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "48px 24px",
    color: "#999",
  },
  variationModalContent: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
  },
  variationAccordion: {
    backgroundColor: "#fff",
    borderRadius: 8,
    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
  },
  variationOptionRow: {
    padding: 4,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  field: {
    marginBottom: theme.spacing(2),
  },
}));

const TIPOS = [
  { value: "fisico", label: "Produto físico" },
  { value: "digital", label: "Produto digital" }
];

const STATUS_LIST = [
  { value: "disponivel", label: "Disponível" },
  { value: "indisponivel", label: "Indisponível" }
];

const ProdutosPage = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const primaryColor = theme.palette.primary.main || "#3b82f6";
  const { showConfirm } = useSystemAlert();

  const [produtos, setProdutos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchParam, setSearchParam] = useState("");

  const [filterTipo, setFilterTipo] = useState("");
  const [filterCategoria, setFilterCategoria] = useState("");

  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogStep, setDialogStep] = useState(1); // 1 = escolher tipo, 2 = demais campos, 3 = selecionar variações, 4 = configurar variações
  const [editingId, setEditingId] = useState(null);

  const [tipo, setTipo] = useState("");
  const [nome, setNome] = useState("");
  const [descricao, setDescricao] = useState("");
  const [valor, setValor] = useState("");
  const [status, setStatus] = useState("disponivel");
  const [imagemPrincipal, setImagemPrincipal] = useState(""); // caminho/identificador futuro
  const [imagemPrincipalFile, setImagemPrincipalFile] = useState(null); // File selecionado
  const [galeriaFiles, setGaleriaFiles] = useState([]); // Novos Files da galeria (ainda não enviados)
  const [galeriaAtual, setGaleriaAtual] = useState([]); // Galeria já salva no banco
  const [saving, setSaving] = useState(false);
  const [categoriaSelecionada, setCategoriaSelecionada] = useState("");
  const [marcaSelecionada, setMarcaSelecionada] = useState("");
  const [linkCompra, setLinkCompra] = useState("");
  const [controleEstoque, setControleEstoque] = useState(false);
  const [estoqueAtual, setEstoqueAtual] = useState("");
  const [estoqueMinimo, setEstoqueMinimo] = useState("");

  const [viewDialogOpen, setViewDialogOpen] = useState(false);
  const [viewProduto, setViewProduto] = useState(null);

  const [categorias, setCategorias] = useState([]);
  const [categoriasLoading, setCategoriasLoading] = useState(false);
  const [categoriaDialogOpen, setCategoriaDialogOpen] = useState(false);
  const [editingCategoriaId, setEditingCategoriaId] = useState(null);
  const [categoriaNome, setCategoriaNome] = useState("");
  const [categoriaSlug, setCategoriaSlug] = useState("");
  const [categoriaDescricao, setCategoriaDescricao] = useState("");
  const [categoriaSaving, setCategoriaSaving] = useState(false);

  const [variacaoGrupos, setVariacaoGrupos] = useState([]);
  const [variacoesLoading, setVariacoesLoading] = useState(false);
  const [grupoModalOpen, setGrupoModalOpen] = useState(false);
  const [editingGrupo, setEditingGrupo] = useState(null);
  const [grupoSaving, setGrupoSaving] = useState(false);
  const [opcaoModalOpen, setOpcaoModalOpen] = useState(false);
  const [grupoSelecionadoOpcao, setGrupoSelecionadoOpcao] = useState(null);
  const [editingOpcao, setEditingOpcao] = useState(null);
  const [opcaoSaving, setOpcaoSaving] = useState(false);

  const [produtoVariacoes, setProdutoVariacoes] = useState([]);
  const [variationModalOpen, setVariationModalOpen] = useState(false);
  const [variationModalProduct, setVariationModalProduct] = useState(null);
  const [variationSelections, setVariationSelections] = useState({});
  const [expandedVariationGroup, setExpandedVariationGroup] = useState(false);
  const [variationSaving, setVariationSaving] = useState(false);

  // Estados para marcas e campos personalizados
  const [marcas, setMarcas] = useState([]);
  const [marcasLoading, setMarcasLoading] = useState(false);
  const [customFields, setCustomFields] = useState([]);
  const [customFieldsLoading, setCustomFieldsLoading] = useState(false);
  const [customFieldValues, setCustomFieldValues] = useState({});

  // Sincronização com catálogo WhatsApp
  const [whatsappConnections, setWhatsappConnections] = useState([]);
  const [selectedWhatsappIds, setSelectedWhatsappIds] = useState([]);

  // Paginação da tabela
  const [tablePage, setTablePage] = useState(0);
  const rowsPerPage = 10;

  const resetForm = () => {
    setEditingId(null);
    setDialogStep(1);
    setTipo("");
    setNome("");
    setDescricao("");
    setValor("");
    setStatus("disponivel");
    setImagemPrincipal("");
    setImagemPrincipalFile(null);
    setGaleriaFiles([]);
    setGaleriaAtual([]);
    setCategoriaSelecionada("");
    setMarcaSelecionada("");
    setLinkCompra("");
    setCustomFieldValues({});
    setControleEstoque(false);
    setEstoqueAtual("");
    setEstoqueMinimo("");
    setProdutoVariacoes([]);
    setSelectedWhatsappIds([]);
  };

  const handleOpenVariationsModal = produto => {
    setVariationModalProduct(produto);
    const selections = {};
    (produto.variacoes || []).forEach(variacao => {
      const grupoId = variacao.opcao?.grupoId;
      if (grupoId) {
        const key = String(grupoId);
        if (!selections[key]) selections[key] = [];
        if (!selections[key].includes(variacao.opcaoId)) {
          selections[key].push(variacao.opcaoId);
        }
      }
    });
    setVariationSelections(selections);
    setExpandedVariationGroup(false);
    setVariationModalOpen(true);
  };

  const handleCloseVariationsModal = () => {
    setVariationModalOpen(false);
    setVariationModalProduct(null);
    setVariationSelections({});
    setExpandedVariationGroup(false);
  };

  const handleToggleGroup = (grupo, checked) => {
    setVariationSelections(prev => {
      const next = { ...prev };
      const key = String(grupo.id);
      if (checked) {
        const defaults = (grupo.opcoes || []).map(opcao => opcao.id);
        const current = next[key] || [];
        const merged = Array.from(new Set([...(current || []), ...defaults]));
        next[key] = merged;
      } else {
        delete next[key];
      }
      return next;
    });
  };

  const handleToggleVariationOption = (grupoId, opcaoId) => {
    setVariationSelections(prev => {
      const next = { ...prev };
      const key = String(grupoId);
      const current = new Set(next[key] || []);
      if (current.has(opcaoId)) {
        current.delete(opcaoId);
      } else {
        current.add(opcaoId);
      }
      if (current.size === 0) {
        delete next[key];
      } else {
        next[key] = Array.from(current);
      }
      return next;
    });
  };

  const handleSaveVariations = async () => {
    if (!variationModalProduct) return;
    setVariationSaving(true);
    try {
      const variacoesPayload = [];
      Object.values(variationSelections).forEach(lista => {
        lista.forEach(opcaoId => {
          variacoesPayload.push({ opcaoId: Number(opcaoId) });
        });
      });

      await api.put(`/produtos/${variationModalProduct.id}`, {
        variacoes: variacoesPayload
      });

      await loadProdutos(filterTipo, filterCategoria);
      handleCloseVariationsModal();
    } catch (err) {
      console.error("Erro ao salvar variações", err);
    } finally {
      setVariationSaving(false);
    }
  };

  const handleOpenGrupoModal = grupo => {
    setEditingGrupo(grupo || null);
    setGrupoModalOpen(true);
  };

  const handleCloseGrupoModal = () => {
    setGrupoModalOpen(false);
    setEditingGrupo(null);
  };

  const handleSubmitGrupo = async ({ nome }) => {
    if (grupoSaving) return;
    setGrupoSaving(true);
    try {
      if (editingGrupo) {
        await api.put(`/produto-variacoes/grupos/${editingGrupo.id}`, { nome });
      } else {
        await api.post("/produto-variacoes/grupos", { nome });
      }
      await loadVariacoes();
      handleCloseGrupoModal();
    } catch (err) {
      console.error("Erro ao salvar grupo de variação", err);
    } finally {
      setGrupoSaving(false);
    }
  };

  const handleDeleteGrupo = async grupo => {
    const confirmed = await showConfirm({
      type: "error",
      title: "Excluir grupo",
      message: `Tem certeza que deseja excluir o grupo "${grupo.nome}" e todas as suas opções?`,
      confirmText: "Sim, excluir",
      cancelText: "Cancelar"
    });

    if (!confirmed) return;

    try {
      await api.delete(`/produto-variacoes/grupos/${grupo.id}`);
      await loadVariacoes();
    } catch (err) {
      console.error("Erro ao excluir grupo", err);
    }
  };

  const handleOpenOpcaoModal = (grupo, opcao = null) => {
    setGrupoSelecionadoOpcao(grupo);
    setEditingOpcao(opcao);
    setOpcaoModalOpen(true);
  };

  const handleCloseOpcaoModal = () => {
    setOpcaoModalOpen(false);
    setGrupoSelecionadoOpcao(null);
    setEditingOpcao(null);
  };

  const handleSubmitOpcao = async ({ nome, ordem }) => {
    if (opcaoSaving) return;
    if (!grupoSelecionadoOpcao) return;
    setOpcaoSaving(true);
    try {
      if (editingOpcao) {
        await api.put(`/produto-variacoes/opcoes/${editingOpcao.id}`, {
          nome,
          ordem
        });
      } else {
        await api.post("/produto-variacoes/opcoes", {
          grupoId: grupoSelecionadoOpcao.id,
          nome,
          ordem
        });
      }
      await loadVariacoes();
      handleCloseOpcaoModal();
    } catch (err) {
      console.error("Erro ao salvar opção de variação", err);
    } finally {
      setOpcaoSaving(false);
    }
  };

  const handleDeleteOpcao = async opcao => {
    const confirmed = await showConfirm({
      type: "error",
      title: "Excluir opção",
      message: `Confirma a exclusão da opção "${opcao.nome}"?`,
      confirmText: "Sim, excluir",
      cancelText: "Cancelar"
    });

    if (!confirmed) return;

    try {
      await api.delete(`/produto-variacoes/opcoes/${opcao.id}`);
      await loadVariacoes();
    } catch (err) {
      console.error("Erro ao excluir opção", err);
    }
  };

  const loadProdutos = async (tipoFiltro = filterTipo, categoriaFiltro = filterCategoria) => {
    setLoading(true);
    try {
      const params = {};
      if (tipoFiltro) {
        params.tipo = tipoFiltro;
      }
      if (categoriaFiltro) {
        params.categoriaId = categoriaFiltro;
      }

      const { data } = await api.get("/produtos", { params });
      setProdutos(data || []);
    } catch (err) {
      console.error("Erro ao carregar produtos", err);
    } finally {
      setLoading(false);
    }
  };

  const loadCategorias = async () => {
    setCategoriasLoading(true);
    try {
      const { data } = await api.get("/produto-categorias");
      setCategorias(data || []);
    } catch (err) {
      console.error("Erro ao carregar categorias", err);
    } finally {
      setCategoriasLoading(false);
    }
  };

  const loadVariacoes = async () => {
    setVariacoesLoading(true);
    try {
      const { data } = await api.get("/produto-variacoes");
      setVariacaoGrupos(data || []);
    } catch (err) {
      console.error("Erro ao carregar variações", err);
    } finally {
      setVariacoesLoading(false);
    }
  };

  const { produtos: produtosEnabled, loading: planLoading } = usePlanPermissions();
  const history = useHistory();

  useEffect(() => {
    if (!planLoading && !produtosEnabled) {
      toast.warn("Seu plano não inclui este recurso.");
      history.push("/");
    }
  }, [planLoading, produtosEnabled]);

  useEffect(() => {
    loadProdutos();
    loadCategorias();
    loadVariacoes();
    loadMarcas();
    loadCustomFields();
    loadWhatsappConnections();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadWhatsappConnections = async () => {
    try {
      const { data } = await api.get("/whatsapp", { params: { session: 0 } });
      const list = Array.isArray(data) ? data : (data?.whatsapps || []);
      setWhatsappConnections(list.filter(w => w.channel !== "whatsapp_official"));
    } catch (err) {
      console.error(err);
    }
  };

  const loadMarcas = async () => {
    setMarcasLoading(true);
    try {
      const { data } = await api.get("/produto-marcas");
      setMarcas(data);
    } catch (err) {
      console.error(err);
      toastError(err);
    } finally {
      setMarcasLoading(false);
    }
  };

  const loadCustomFields = async () => {
    setCustomFieldsLoading(true);
    try {
      const { data } = await api.get("/produto-custom-fields");
      setCustomFields(data);
    } catch (err) {
      console.error(err);
      toastError(err);
    } finally {
      setCustomFieldsLoading(false);
    }
  };

  useEffect(() => {
    if (tipo !== "fisico") {
      setControleEstoque(false);
      setEstoqueAtual("");
      setEstoqueMinimo("");
    }
  }, [tipo]);

  const handleFilterChange = async event => {
    const value = event.target.value;
    setFilterTipo(value);
    await loadProdutos(value, filterCategoria);
  };

  const handleCategoriaFilterChange = async event => {
    const value = event.target.value;
    setFilterCategoria(value);
    await loadProdutos(filterTipo, value);
  };

  const handleOpenCategoriaDialog = categoria => {
    if (categoria) {
      setEditingCategoriaId(categoria.id);
      setCategoriaNome(categoria.nome || "");
      setCategoriaSlug(categoria.slug || "");
      setCategoriaDescricao(categoria.descricao || "");
    } else {
      setEditingCategoriaId(null);
      setCategoriaNome("");
      setCategoriaSlug("");
      setCategoriaDescricao("");
    }
    setCategoriaDialogOpen(true);
  };

  const handleCloseCategoriaDialog = () => {
    setCategoriaDialogOpen(false);
  };

  const handleSaveCategoria = async event => {
    event.preventDefault();
    if (!categoriaNome) return;
    setCategoriaSaving(true);
    try {
      const payload = {
        nome: categoriaNome,
        slug: categoriaSlug || null,
        descricao: categoriaDescricao || null
      };

      if (editingCategoriaId) {
        await api.put(`/produto-categorias/${editingCategoriaId}`, payload);
      } else {
        await api.post("/produto-categorias", payload);
      }

      await loadCategorias();
      await loadProdutos();
      setCategoriaDialogOpen(false);
    } catch (err) {
      console.error("Erro ao salvar categoria", err);
    } finally {
      setCategoriaSaving(false);
    }
  };

  const handleDeleteCategoria = async categoria => {
    const confirmed = await showConfirm({
      type: "error",
      title: "Excluir categoria",
      message: `Tem certeza que deseja excluir a categoria "${categoria.nome}"?`,
      confirmText: "Sim, excluir",
      cancelText: "Cancelar"
    });

    if (!confirmed) return;

    try {
      await api.delete(`/produto-categorias/${categoria.id}`);
      if (filterCategoria === String(categoria.id)) {
        setFilterCategoria("");
      }
      await loadCategorias();
      await loadProdutos();
    } catch (err) {
      console.error("Erro ao excluir categoria", err);
    }
  };

  const handleOpenCreate = () => {
    resetForm();
    setDialogOpen(true);
  };

  const handleOpenEdit = produto => {
    setEditingId(produto.id);
    setTipo(produto.tipo || "");
    setNome(produto.nome || "");
    setDescricao(produto.descricao || "");
    setValor(produto.valor != null ? String(produto.valor) : "");
    setStatus(produto.status || "disponivel");
    setImagemPrincipal(produto.imagem_principal || "");
    setImagemPrincipalFile(null);
    setGaleriaFiles([]);
    setGaleriaAtual(Array.isArray(produto.galeria) ? produto.galeria : []);
    setCategoriaSelecionada(produto.categoriaId ? String(produto.categoriaId) : "");
    setMarcaSelecionada(produto.marcaId ? String(produto.marcaId) : "");
    setLinkCompra(produto.linkCompra || "");
    
    // Carregar campos personalizados
    const customFieldValuesMap = {};
    if (Array.isArray(produto.customFields)) {
      produto.customFields.forEach(cf => {
        customFieldValuesMap[String(cf.fieldDefinitionId)] = cf.valorTexto;
      });
    }
    setCustomFieldValues(customFieldValuesMap);
    
    // Carregar conexões sincronizadas
    if (Array.isArray(produto.whatsappSyncs)) {
      setSelectedWhatsappIds(produto.whatsappSyncs.map(s => s.whatsappId));
    } else {
      setSelectedWhatsappIds([]);
    }

    setControleEstoque(Boolean(produto.controleEstoque));
    setEstoqueAtual(
      produto.controleEstoque && produto.estoqueAtual != null ? String(produto.estoqueAtual) : ""
    );
    setEstoqueMinimo(
      produto.controleEstoque && produto.estoqueMinimo != null ? String(produto.estoqueMinimo) : ""
    );
    setProdutoVariacoes(
      Array.isArray(produto.variacoes)
        ? produto.variacoes.map(v => ({
            opcaoId: v.opcaoId,
            valorOverride: v.valorOverride || null,
            estoqueOverride: v.estoqueOverride || null
          }))
        : []
    );
    setDialogStep(2);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const handleNextStep = () => {
    if (!tipo) return;
    setDialogStep(2);
  };

  const handleNextToVariacoes = () => {
    setDialogStep(3);
  };

  const handleNextToConfigVariacoes = () => {
    setDialogStep(4);
  };

  const handleOpenEditVariacoes = produto => {
    setEditingId(produto.id);
    setNome(produto.nome || "");
    setProdutoVariacoes(
      Array.isArray(produto.variacoes)
        ? produto.variacoes.map(v => ({
            opcaoId: v.opcaoId,
            valorOverride: v.valorOverride || null,
            estoqueOverride: v.estoqueOverride || null
          }))
        : []
    );
    setDialogStep(3);
    setDialogOpen(true);
  };

  const handleSave = async event => {
    event.preventDefault();
    if (!tipo || !nome || !valor) return;

    console.log("Iniciando salvamento do produto...");
    console.log("produtoVariacoes:", produtoVariacoes);
    console.log("dialogStep:", dialogStep);
    console.log("editingId:", editingId);

    setSaving(true);

    try {
      // 1) Upload da imagem principal, se um novo arquivo foi selecionado
      let mainImage = imagemPrincipal || null;
      if (imagemPrincipalFile) {
        const formData = new FormData();
        formData.append("typeArch", "produtos");
        formData.append("file", imagemPrincipalFile);

        const { data } = await api.post("/produtos/upload-imagem", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        });
        mainImage = data.filename || null;
      }

      // 2) Upload da galeria, se houver novos arquivos selecionados
      let galeriaNovas = [];
      if (galeriaFiles.length > 0) {
        const filenames = [];
        for (const file of galeriaFiles) {
          const formData = new FormData();
          formData.append("typeArch", "produtos");
          formData.append("file", file);

          const { data } = await api.post("/produtos/upload-imagem", formData, {
            headers: { "Content-Type": "multipart/form-data" }
          });

          if (data.filename) {
            filenames.push(data.filename);
          }
        }

        if (filenames.length > 0) {
          galeriaNovas = filenames;
        }
      }

      const galeriaFinal = [...(Array.isArray(galeriaAtual) ? galeriaAtual : []), ...galeriaNovas];

      // Preparar campos personalizados
      const customFieldsPayload = [];
      Object.entries(customFieldValues).forEach(([fieldId, value]) => {
        if (value !== null && value !== undefined) {
          customFieldsPayload.push({
            fieldDefinitionId: Number(fieldId),
            valorTexto: String(value)
          });
        }
      });

      console.log("CustomFields values:", customFieldValues);
      console.log("CustomFields payload:", customFieldsPayload);

      const isProdutoFisico = tipo === "fisico";
      const payload = {
        tipo,
        nome,
        descricao,
        valor: Number(valor),
        status,
        imagem_principal: mainImage,
        ...(linkCompra ? { linkCompra } : {}),
        ...(galeriaFinal.length ? { galeria: galeriaFinal } : {}),
        ...(categoriaSelecionada ? { categoriaId: Number(categoriaSelecionada) } : {}),
        ...(marcaSelecionada ? { marcaId: Number(marcaSelecionada) } : {}),
        ...(customFieldsPayload.length ? { customFields: customFieldsPayload } : {}),
        ...(isProdutoFisico
          ? {
              controleEstoque,
              estoqueAtual: controleEstoque ? Number(estoqueAtual || 0) : 0,
              estoqueMinimo: controleEstoque ? Number(estoqueMinimo || 0) : 0
            }
          : {
              controleEstoque: false,
              estoqueAtual: 0,
              estoqueMinimo: 0
            }),
        ...(produtoVariacoes.length ? { variacoes: produtoVariacoes } : {}),
        whatsappIds: selectedWhatsappIds
      };

      console.log("Payload enviado ao backend:", payload);

      try {
        if (editingId) {
          await api.put(`/produtos/${editingId}`, payload);
        } else {
          await api.post("/produtos", payload);
        }

        await loadProdutos();
        setDialogOpen(false);
        resetForm();
      } catch (err) {
        console.error("Erro ao salvar produto", err);
        if (err.response) {
          console.error("Response data:", err.response.data);
          console.error("Response status:", err.response.status);
        }
      } finally {
        setSaving(false);
      }
    } catch (err) {
      console.error("Erro ao salvar produto", err);
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async id => {
    const confirmed = await showConfirm({
      type: "error",
      title: "Excluir Produto",
      message: "Deseja realmente excluir este produto?",
      confirmText: "Sim, excluir",
      cancelText: "Cancelar",
    });
    if (!confirmed) return;

    try {
      await api.delete(`/produtos/${id}`);
      await loadProdutos();
    } catch (err) {
      console.error("Erro ao excluir produto", err);
    }
  };

  const renderTipoLabel = value => {
    const item = TIPOS.find(t => t.value === value);
    return item ? item.label : value;
  };

  const renderStatusLabel = value => {
    const item = STATUS_LIST.find(s => s.value === value);
    return item ? item.label : value;
  };

  const getImageUrl = (companyId, filename) => {
    if (!filename) return null;
    const baseUrl = process.env.REACT_APP_BACKEND_URL || "";

    // Novo formato: já vem com caminho completo relativo (ex.: company1/produtos/arquivo.png)
    if (filename.includes("company")) {
      return `${baseUrl}/public/${filename}`;
    }

    // Formato legado: apenas o nome do arquivo salvo na raiz da pasta da company
    if (companyId) {
      return `${baseUrl}/public/company${companyId}/${filename}`;
    }

    // Fallback genérico
    return `${baseUrl}/public/${filename}`;
  };

  const handleRemoveGaleriaImage = async (produto, index) => {
    if (!Array.isArray(produto.galeria)) return;

    const novaGaleria = produto.galeria.filter((_, i) => i !== index);

    try {
      await api.put(`/produtos/${produto.id}`, { galeria: novaGaleria });

      // atualiza lista completa
      await loadProdutos(filterTipo);

      // atualiza produto em visualização, se for o mesmo
      if (viewProduto && viewProduto.id === produto.id) {
        setViewProduto({ ...viewProduto, galeria: novaGaleria });
      }
    } catch (err) {
      console.error("Erro ao remover imagem da galeria", err);
    }
  };

  const filteredProdutos = produtos.filter((produto) =>
    produto.nome?.toLowerCase().includes(searchParam.toLowerCase())
  );

  const getStatusChip = (status) => {
    if (status === "disponivel") {
      return (
        <Chip
          label="Disponível"
          size="small"
          className={classes.statusChip}
          style={{ backgroundColor: "#e8f5e9", color: "#4caf50" }}
        />
      );
    }
    return (
      <Chip
        label="Indisponível"
        size="small"
        className={classes.statusChip}
        style={{ backgroundColor: "#ffebee", color: "#d32f2f" }}
      />
    );
  };

  const paginatedProdutos = filteredProdutos.slice(tablePage * rowsPerPage, (tablePage + 1) * rowsPerPage);
  const totalPages = Math.ceil(filteredProdutos.length / rowsPerPage);

  return (
    <Box className={classes.root} style={{ "--primary-color": primaryColor }}>
      {/* Header */}
      <Box className={classes.header}>
        <Box className={classes.headerLeft}>
          <Box>
            <Typography className={classes.headerTitle}>Produtos</Typography>
            <Typography className={classes.headerSubtitle}>
              {filteredProdutos.length} {filteredProdutos.length === 1 ? "produto encontrado" : "produtos encontrados"}
            </Typography>
          </Box>
        </Box>

        <Box className={classes.headerRight}>
          <FormControl variant="outlined" size="small" className={classes.filterSelect}>
            <InputLabel>Tipo</InputLabel>
            <Select value={filterTipo} onChange={handleFilterChange} label="Tipo">
              <MenuItem value=""><em>Todos</em></MenuItem>
              {TIPOS.map(t => <MenuItem key={t.value} value={t.value}>{t.label}</MenuItem>)}
            </Select>
          </FormControl>
          <FormControl variant="outlined" size="small" className={classes.filterSelect}>
            <InputLabel>Categoria</InputLabel>
            <Select value={filterCategoria} onChange={handleCategoriaFilterChange} label="Categoria">
              <MenuItem value=""><em>Todas</em></MenuItem>
              {categorias.map(cat => <MenuItem key={cat.id} value={String(cat.id)}>{cat.nome}</MenuItem>)}
            </Select>
          </FormControl>
          <TextField
            placeholder="Buscar produto..."
            variant="outlined"
            size="small"
            value={searchParam}
            onChange={(e) => { setSearchParam(e.target.value); setTablePage(0); }}
            className={classes.searchField}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon style={{ color: "#999" }} />
                </InputAdornment>
              ),
            }}
          />
          <CatalogoPublicoBotao />
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={handleOpenCreate}
            className={classes.addButton}
          >
            Novo Produto
          </Button>
        </Box>
      </Box>

      {/* Content */}
      <Box className={classes.content}>
        <Box className={classes.tableWrapper}>
          <Box className={classes.tableScroll}>
          <Table size="small">
            <TableHead className={classes.tableHead}>
              <TableRow>
                <TableCell style={{ width: 56 }}></TableCell>
                <TableCell>Nome</TableCell>
                <TableCell align="center">Tipo</TableCell>
                <TableCell align="center">Categoria</TableCell>
                <TableCell align="center">Marca</TableCell>
                <TableCell align="right">Valor</TableCell>
                <TableCell align="center">Estoque</TableCell>
                <TableCell align="center">Status</TableCell>
                <TableCell align="center">Ações</TableCell>
              </TableRow>
            </TableHead>
            <TableBody className={classes.tableBody}>
              {loading && produtos.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={9}>
                    <Box className={classes.emptyState}><CircularProgress size={32} /></Box>
                  </TableCell>
                </TableRow>
              ) : paginatedProdutos.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={9}>
                    <Box className={classes.emptyState}>
                      <ShoppingBasketIcon style={{ fontSize: 48, marginBottom: 12, opacity: 0.3 }} />
                      <Typography>Nenhum produto encontrado</Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              ) : (
                paginatedProdutos.map((produto) => (
                  <TableRow key={produto.id}>
                    <TableCell>
                      {produto.imagem_principal ? (
                        <img
                          src={getImageUrl(produto.companyId, produto.imagem_principal)}
                          alt={produto.nome}
                          className={classes.thumbImg}
                        />
                      ) : (
                        <Box className={classes.thumbPlaceholder}>
                          <ShoppingBasketIcon />
                        </Box>
                      )}
                    </TableCell>
                    <TableCell>
                      <Typography style={{ fontWeight: 600, fontSize: "0.875rem" }}>{produto.nome}</Typography>
                      {produto.descricao && (
                        <Typography variant="caption" style={{ color: "#94a3b8" }} noWrap>
                          {produto.descricao.substring(0, 60)}{produto.descricao.length > 60 ? "…" : ""}
                        </Typography>
                      )}
                    </TableCell>
                    <TableCell align="center">
                      <Chip
                        label={renderTipoLabel(produto.tipo)}
                        size="small"
                        style={{
                          backgroundColor: produto.tipo === "fisico" ? "#e0f2fe" : "#f3e8ff",
                          color: produto.tipo === "fisico" ? "#0369a1" : "#7c3aed",
                          fontWeight: 600, fontSize: "0.72rem",
                        }}
                      />
                    </TableCell>
                    <TableCell align="center" style={{ color: "#64748b" }}>
                      {produto.categoria?.nome || "—"}
                    </TableCell>
                    <TableCell align="center" style={{ color: "#64748b" }}>
                      {produto.marca?.nome || "—"}
                    </TableCell>
                    <TableCell align="right" style={{ fontWeight: 700 }}>
                      {new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(produto.valor || 0)}
                    </TableCell>
                    <TableCell align="center" style={{ color: "#64748b" }}>
                      {produto.controleEstoque ? `${produto.estoqueAtual ?? 0} un` : "—"}
                    </TableCell>
                    <TableCell align="center">
                      {getStatusChip(produto.status)}
                    </TableCell>
                    <TableCell align="center">
                      {isMobile ? (
                        <MobileActionMenu actions={[
                          { label: "Visualizar imagens", icon: <VisibilityIcon fontSize="small" />, onClick: () => { setViewProduto(produto); setViewDialogOpen(true); } },
                          { label: "Editar", icon: <EditIcon fontSize="small" />, onClick: () => handleOpenEdit(produto) },
                          { label: "Gerenciar variações", icon: <BallotIcon fontSize="small" />, onClick: () => handleOpenVariationsModal(produto) },
                          { label: "Excluir", icon: <DeleteOutlineIcon fontSize="small" />, onClick: () => handleDelete(produto.id), color: "#ef4444" },
                        ]} />
                      ) : (
                        <Box display="flex" justifyContent="center" style={{ gap: 4 }}>
                          <Tooltip title="Visualizar imagens">
                            <IconButton size="small" style={{ color: "#6366f1" }} onClick={() => { setViewProduto(produto); setViewDialogOpen(true); }}>
                              <VisibilityIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Editar">
                            <IconButton size="small" style={{ color: "#1976d2" }} onClick={() => handleOpenEdit(produto)}>
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Gerenciar variações">
                            <IconButton size="small" style={{ color: "#0891b2" }} onClick={() => handleOpenVariationsModal(produto)}>
                              <BallotIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Excluir">
                            <IconButton size="small" style={{ color: "#ef4444" }} onClick={() => handleDelete(produto.id)}>
                              <DeleteOutlineIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      )}
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
          </Box>

          {filteredProdutos.length > 0 && (
            <Box className={classes.paginationBar}>
              <Typography variant="body2" style={{ color: "#666" }}>
                Exibindo {tablePage * rowsPerPage + 1} a {Math.min((tablePage + 1) * rowsPerPage, filteredProdutos.length)} de {filteredProdutos.length} produto(s)
              </Typography>
              <Box display="flex" alignItems="center" style={{ gap: 8 }}>
                <Button size="small" disabled={tablePage === 0} onClick={() => setTablePage(p => p - 1)} className={classes.actionBtn}>
                  Anterior
                </Button>
                {Array.from({ length: Math.min(totalPages, 5) }, (_, i) => {
                  let idx = i;
                  if (totalPages > 5) {
                    const start = Math.max(0, Math.min(tablePage - 2, totalPages - 5));
                    idx = start + i;
                  }
                  return (
                    <Button
                      key={idx}
                      size="small"
                      variant={idx === tablePage ? "contained" : "text"}
                      color={idx === tablePage ? "primary" : "default"}
                      onClick={() => setTablePage(idx)}
                      style={{ minWidth: 32, borderRadius: 6, fontWeight: idx === tablePage ? 700 : 400 }}
                    >
                      {idx + 1}
                    </Button>
                  );
                })}
                <Button size="small" disabled={tablePage >= totalPages - 1} onClick={() => setTablePage(p => p + 1)} className={classes.actionBtn}>
                  Próximo
                </Button>
              </Box>
            </Box>
          )}
        </Box>
      </Box>

      <Dialog open={dialogOpen} onClose={handleCloseDialog} maxWidth="lg" fullWidth>
        <DialogTitle>
          {editingId ? "Editar produto" : "Adicionar produto"}
        </DialogTitle>
        <DialogContent>
          {dialogStep === 1 && (
            <FormControl variant="outlined" fullWidth className={classes.field}>
              <InputLabel id="tipo-label">Tipo do produto</InputLabel>
              <Select
                labelId="tipo-label"
                value={tipo}
                onChange={e => setTipo(e.target.value)}
                label="Tipo do produto"
              >
                {TIPOS.map(t => (
                  <MenuItem key={t.value} value={t.value}>
                    {t.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

          {dialogStep === 2 && (
            <form id="produto-form" onSubmit={handleSave}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <FormControl variant="outlined" fullWidth className={classes.field}>
                    <InputLabel id="tipo-edit-label">Tipo do produto</InputLabel>
                    <Select
                      labelId="tipo-edit-label"
                      value={tipo}
                      onChange={e => setTipo(e.target.value)}
                      label="Tipo do produto"
                      required
                    >
                      {TIPOS.map(t => (
                        <MenuItem key={t.value} value={t.value}>
                          {t.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                {tipo === "fisico" && (
                  <Grid item xs={12}>
                    <FormControlLabel
                      control={
                        <Switch
                          color="primary"
                          checked={controleEstoque}
                          onChange={e => setControleEstoque(e.target.checked)}
                        />
                      }
                      label="Habilitar controle de estoque"
                    />
                  </Grid>
                )}

                {tipo === "fisico" && controleEstoque && (
                  <>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Estoque atual"
                        type="number"
                        value={estoqueAtual}
                        onChange={e => setEstoqueAtual(e.target.value)}
                        variant="outlined"
                        fullWidth
                        className={classes.field}
                        inputProps={{ min: 0 }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Estoque mínimo"
                        type="number"
                        value={estoqueMinimo}
                        onChange={e => setEstoqueMinimo(e.target.value)}
                        variant="outlined"
                        fullWidth
                        className={classes.field}
                        inputProps={{ min: 0 }}
                      />
                    </Grid>
                  </>
                )}

                <Grid item xs={12}>
                  <FormControl variant="outlined" fullWidth className={classes.field}>
                    <InputLabel id="categoria-label">Categoria</InputLabel>
                    <Select
                      labelId="categoria-label"
                      value={categoriaSelecionada}
                      onChange={e => setCategoriaSelecionada(e.target.value)}
                      label="Categoria"
                    >
                      <MenuItem value="">
                        <em>Sem categoria</em>
                      </MenuItem>
                      {categorias.map(cat => (
                        <MenuItem key={cat.id} value={String(cat.id)}>
                          {cat.nome}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <FormControl variant="outlined" fullWidth className={classes.field}>
                    <InputLabel id="marca-label">Marca</InputLabel>
                    <Select
                      labelId="marca-label"
                      value={marcaSelecionada}
                      onChange={e => setMarcaSelecionada(e.target.value)}
                      label="Marca"
                    >
                      <MenuItem value="">
                        <em>Sem marca</em>
                      </MenuItem>
                      {marcas.filter(m => m.active).map(marca => (
                        <MenuItem key={marca.id} value={String(marca.id)}>
                          {marca.nome}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <FormControl variant="outlined" fullWidth className={classes.field}>
                    <InputLabel id="status-label">Status</InputLabel>
                    <Select
                      labelId="status-label"
                      value={status}
                      onChange={e => setStatus(e.target.value)}
                      label="Status"
                      required
                    >
                      {STATUS_LIST.map(s => (
                        <MenuItem key={s.value} value={s.value}>
                          {s.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    label="Nome do produto"
                    value={nome}
                    onChange={e => setNome(e.target.value)}
                    variant="outlined"
                    fullWidth
                    className={classes.field}
                    required
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    label="Descrição"
                    value={descricao}
                    onChange={e => setDescricao(e.target.value)}
                    variant="outlined"
                    fullWidth
                    multiline
                    rows={3}
                    className={classes.field}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Valor"
                    type="number"
                    value={valor}
                    onChange={e => setValor(e.target.value)}
                    variant="outlined"
                    fullWidth
                    className={classes.field}
                    required
                    inputProps={{ min: 0, step: 0.01 }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    label="Link de Compra (opcional)"
                    value={linkCompra}
                    onChange={e => setLinkCompra(e.target.value)}
                    variant="outlined"
                    fullWidth
                    className={classes.field}
                    placeholder="https://..."
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <div className={classes.field}>
                    <Typography variant="subtitle2" gutterBottom>
                      Imagem principal
                    </Typography>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={e => {
                        const file = e.target.files && e.target.files[0];
                        setImagemPrincipalFile(file || null);
                      }}
                    />
                    {imagemPrincipal && (
                      <Typography variant="caption" display="block">
                        Arquivo atual: {imagemPrincipal}
                      </Typography>
                    )}
                  </div>
                </Grid>

                <Grid item xs={12}>
                  <div className={classes.field}>
                    <Typography variant="subtitle2" gutterBottom>
                      Galeria de imagens
                    </Typography>
                    <input
                      type="file"
                      accept="image/*"
                      multiple
                      onChange={e => {
                        const files = e.target.files ? Array.from(e.target.files) : [];
                        setGaleriaFiles(files);
                      }}
                    />
                    {galeriaFiles.length > 0 && (
                      <Typography variant="caption" display="block">
                        {galeriaFiles.length} arquivo(s) selecionado(s) para galeria
                      </Typography>
                    )}
                  </div>
                </Grid>

                {customFields.length > 0 && (
                  <Grid item xs={12}>
                    <Accordion className={classes.field}>
                      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography variant="subtitle2">Campos Personalizados</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Grid container spacing={2}>
                          {customFields.map(field => (
                            <Grid item xs={12} sm={6} key={field.id}>
                              {field.tipo === "texto" && (
                                <TextField
                                  label={field.nome}
                                  value={customFieldValues[String(field.id)] || ""}
                                  onChange={e => {
                                    e.persist();
                                    setCustomFieldValues(prev => ({
                                      ...prev,
                                      [String(field.id)]: e.target.value
                                    }));
                                  }}
                                  variant="outlined"
                                  fullWidth
                                  required={field.obrigatorio}
                                />
                              )}
                              {field.tipo === "numero" && (
                                <TextField
                                  label={field.nome}
                                  type="number"
                                  value={customFieldValues[String(field.id)] || ""}
                                  onChange={e => {
                                    e.persist();
                                    setCustomFieldValues(prev => ({
                                      ...prev,
                                      [String(field.id)]: e.target.value
                                    }));
                                  }}
                                  variant="outlined"
                                  fullWidth
                                  required={field.obrigatorio}
                                />
                              )}
                              {field.tipo === "data" && (
                                <TextField
                                  label={field.nome}
                                  type="date"
                                  value={customFieldValues[String(field.id)] || ""}
                                  onChange={e => {
                                    e.persist();
                                    setCustomFieldValues(prev => ({
                                      ...prev,
                                      [String(field.id)]: e.target.value
                                    }));
                                  }}
                                  variant="outlined"
                                  fullWidth
                                  InputLabelProps={{ shrink: true }}
                                  required={field.obrigatorio}
                                />
                              )}
                              {field.tipo === "boolean" && (
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={customFieldValues[String(field.id)] === true}
                                      onChange={e => {
                                        e.persist();
                                        setCustomFieldValues(prev => ({
                                          ...prev,
                                          [String(field.id)]: e.target.checked
                                        }));
                                      }}
                                      color="primary"
                                    />
                                  }
                                  label={field.nome}
                                />
                              )}
                              {field.tipo === "select" && (
                                <FormControl variant="outlined" fullWidth>
                                  <InputLabel>{field.nome}</InputLabel>
                                  <Select
                                    value={customFieldValues[String(field.id)] || ""}
                                    onChange={e => {
                                      e.persist();
                                      setCustomFieldValues(prev => ({
                                        ...prev,
                                        [String(field.id)]: e.target.value
                                      }));
                                    }}
                                    label={field.nome}
                                    required={field.obrigatorio}
                                  >
                                    <MenuItem value="">
                                      <em>Selecione...</em>
                                    </MenuItem>
                                    {Array.isArray(field.opcoes) && field.opcoes.map((opcao, idx) => (
                                      <MenuItem key={idx} value={opcao}>
                                        {opcao}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              )}
                            </Grid>
                          ))}
                        </Grid>
                      </AccordionDetails>
                    </Accordion>
                  </Grid>
                )}

                {whatsappConnections.length > 0 && (
                  <Grid item xs={12}>
                    <Typography variant="subtitle2" style={{ marginBottom: 8, color: "#444" }}>
                      Sincronizar com catálogo WhatsApp
                    </Typography>
                    <Box style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                      {whatsappConnections.map(conn => {
                        const selected = selectedWhatsappIds.includes(conn.id);
                        return (
                          <Chip
                            key={conn.id}
                            label={conn.name || `Conexão ${conn.id}`}
                            clickable
                            color={selected ? "primary" : "default"}
                            variant={selected ? "default" : "outlined"}
                            onClick={() => {
                              setSelectedWhatsappIds(prev =>
                                selected ? prev.filter(id => id !== conn.id) : [...prev, conn.id]
                              );
                            }}
                          />
                        );
                      })}
                    </Box>
                    <Typography variant="caption" style={{ color: "#888", marginTop: 4, display: "block" }}>
                      Selecione as conexões onde este produto será publicado no catálogo do WhatsApp Business.
                    </Typography>
                  </Grid>
                )}
              </Grid>
            </form>
          )}

          {dialogStep === 3 && (
            <Box>
              <Typography variant="h6" gutterBottom>
                Selecionar Variações
              </Typography>
              {variacaoGrupos.length === 0 ? (
                <Typography variant="body2" color="textSecondary">
                  Nenhum grupo de variações cadastrado. Use o painel lateral para criar grupos e opções.
                </Typography>
              ) : (
                <Grid container spacing={2}>
                  {variacaoGrupos.map(grupo => (
                    <Grid item xs={12} sm={6} key={grupo.id}>
                      <FormControl variant="outlined" fullWidth>
                        <InputLabel>{grupo.nome}</InputLabel>
                        <Select
                          label={grupo.nome}
                          multiple
                          value={produtoVariacoes
                            .filter(v => grupo.opcoes.some(o => o.id === v.opcaoId))
                            .map(v => v.opcaoId)}
                          onChange={e => {
                            const selected = e.target.value;
                            const novas = produtoVariacoes.filter(v => !grupo.opcoes.some(o => o.id === v.opcaoId));
                            selected.forEach(opcaoId => {
                              if (!novas.find(v => v.opcaoId === opcaoId)) {
                                novas.push({ opcaoId, valorOverride: null, estoqueOverride: null });
                              }
                            });
                            setProdutoVariacoes(novas);
                          }}
                          renderValue={selectedIds => (
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                              {selectedIds.map(id => {
                                const opt = grupo.opcoes.find(o => o.id === id);
                                return <Chip key={id} label={opt?.nome || id} size="small" />;
                              })}
                            </Box>
                          )}
                        >
                          {grupo.opcoes.map(opcao => (
                            <MenuItem key={opcao.id} value={opcao.id}>
                              {opcao.nome}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  ))}
                </Grid>
              )}
            </Box>
          )}

          {dialogStep === 4 && (
            <Box>
              <Typography variant="h6" gutterBottom>
                Configurar Variações
              </Typography>
              {produtoVariacoes.length === 0 ? (
                <Typography variant="body2" color="textSecondary">
                  Nenhuma variação selecionada.
                </Typography>
              ) : (
                <Grid container spacing={2}>
                  {produtoVariacoes.map((variacao, idx) => {
                    const opt = variacaoGrupos.flatMap(g => g.opcoes).find(o => o.id === variacao.opcaoId);
                    return (
                      <Grid item xs={12} key={variacao.opcaoId}>
                        <Box p={2} border={1} borderColor="grey.300" borderRadius={4}>
                          <Typography variant="subtitle2">{opt?.nome || `Opção ${variacao.opcaoId}`}</Typography>
                          <Grid container spacing={2} mt={1}>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                label="Valor"
                                type="number"
                                value={variacao.valorOverride ?? ""}
                                onChange={e => {
                                  const val = e.target.value;
                                  const updated = [...produtoVariacoes];
                                  updated[idx].valorOverride = val ? Number(val) : null;
                                  setProdutoVariacoes(updated);
                                }}
                                variant="outlined"
                                fullWidth
                                inputProps={{ min: 0, step: 0.01 }}
                                helperText="Deixe em branco para usar o valor padrão"
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                label="Estoque"
                                type="number"
                                value={variacao.estoqueOverride ?? ""}
                                onChange={e => {
                                  const val = e.target.value;
                                  const updated = [...produtoVariacoes];
                                  updated[idx].estoqueOverride = val ? Number(val) : null;
                                  setProdutoVariacoes(updated);
                                }}
                                variant="outlined"
                                fullWidth
                                inputProps={{ min: 0 }}
                                helperText="Deixe em branco para usar o estoque padrão"
                              />
                            </Grid>
                          </Grid>
                        </Box>
                      </Grid>
                    );
                  })}
                </Grid>
              )}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Cancelar</Button>
          {dialogStep === 1 && (
            <Button
              color="primary"
              variant="contained"
              onClick={handleNextStep}
              disabled={!tipo}
            >
              Próximo
            </Button>
          )}
          {dialogStep === 2 && (
            <Button
              color="primary"
              variant="contained"
              onClick={handleNextToVariacoes}
              disabled={!nome || !valor}
            >
              Próximo
            </Button>
          )}
          {dialogStep === 3 && (
            <Button
              color="primary"
              variant="contained"
              onClick={handleNextToConfigVariacoes}
            >
              Próximo
            </Button>
          )}
          {dialogStep === 4 && (
            <form id="produto-form" onSubmit={handleSave}>
              <Button
                color="primary"
                variant="contained"
                type="submit"
                disabled={saving}
              >
                {editingId ? "Salvar alterações" : "Criar produto"}
              </Button>
            </form>
          )}
        </DialogActions>
      </Dialog>

      <Dialog open={categoriaDialogOpen} onClose={handleCloseCategoriaDialog} maxWidth="lg" fullWidth>
        <DialogTitle>{editingCategoriaId ? "Editar categoria" : "Nova categoria"}</DialogTitle>
        <DialogContent>
          <form id="categoria-form" onSubmit={handleSaveCategoria}>
            <TextField
              label="Nome"
              value={categoriaNome}
              onChange={e => setCategoriaNome(e.target.value)}
              variant="outlined"
              fullWidth
              className={classes.field}
              required
            />
            <TextField
              label="Slug (opcional)"
              value={categoriaSlug}
              onChange={e => setCategoriaSlug(e.target.value)}
              variant="outlined"
              fullWidth
              className={classes.field}
            />
            <TextField
              label="Descrição"
              value={categoriaDescricao}
              onChange={e => setCategoriaDescricao(e.target.value)}
              variant="outlined"
              fullWidth
              className={classes.field}
              multiline
              rows={3}
            />
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseCategoriaDialog}>Cancelar</Button>
          <Button color="primary" variant="contained" type="submit" form="categoria-form" disabled={categoriaSaving}>
            {categoriaSaving ? "Salvando..." : "Salvar"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={viewDialogOpen}
        onClose={() => {
          setViewDialogOpen(false);
          setViewProduto(null);
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Imagens do produto</DialogTitle>
        <DialogContent>
          {viewProduto && (
            <Grid container spacing={2}>
              {viewProduto.imagem_principal && (
                <Grid item xs={12}>
                  <Typography variant="subtitle2" gutterBottom>
                    Imagem principal
                  </Typography>
                  <img
                    src={getImageUrl(viewProduto.companyId, viewProduto.imagem_principal)}
                    alt={viewProduto.nome}
                    style={{ maxWidth: "100%", borderRadius: 8 }}
                  />
                </Grid>
              )}

              {Array.isArray(viewProduto.galeria) && viewProduto.galeria.length > 0 && (
                <Grid item xs={12}>
                  <Typography variant="subtitle2" gutterBottom>
                    Galeria
                  </Typography>
                  <Grid container spacing={2}>
                    {viewProduto.galeria.map((img, index) => (
                      <Grid item xs={6} sm={4} md={3} key={`${img}-${index}`}>
                        <div style={{ position: "relative" }}>
                          <img
                            src={getImageUrl(viewProduto.companyId, img)}
                            alt={`${viewProduto.nome} ${index + 1}`}
                            style={{ width: "100%", borderRadius: 8, objectFit: "cover" }}
                          />
                          <IconButton
                            size="small"
                            style={{
                              position: "absolute",
                              top: 4,
                              right: 4,
                              backgroundColor: "rgba(0,0,0,0.6)",
                              color: "#fff"
                            }}
                            onClick={() => handleRemoveGaleriaImage(viewProduto, index)}
                          >
                            <CloseIcon style={{ fontSize: 16 }} />
                          </IconButton>
                        </div>
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
              )}

              {!viewProduto.imagem_principal &&
                (!viewProduto.galeria || viewProduto.galeria.length === 0) && (
                  <Grid item xs={12}>
                    <Typography>Nenhuma imagem cadastrada para este produto.</Typography>
                  </Grid>
                )}
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setViewDialogOpen(false);
              setViewProduto(null);
            }}
          >
            Fechar
          </Button>
        </DialogActions>
      </Dialog>

      
      <Dialog open={variationModalOpen} onClose={handleCloseVariationsModal} maxWidth="md" fullWidth>
        <DialogTitle>
          Gerenciar variações {variationModalProduct ? `- ${variationModalProduct.nome}` : ""}
        </DialogTitle>
        <DialogContent dividers>
          {variacaoGrupos.length === 0 ? (
            <Typography variant="body2" color="textSecondary">
              Nenhum grupo de variações cadastrado.
            </Typography>
          ) : (
            <Box className={classes.variationModalContent}>
              {variacaoGrupos.map(grupo => {
                const key = String(grupo.id);
                const selectedIds = variationSelections[key] || [];
                const isGroupSelected = selectedIds.length > 0;
                return (
                  <Accordion
                    key={grupo.id}
                    className={classes.variationAccordion}
                    expanded={expandedVariationGroup === grupo.id}
                    onChange={(_, expanded) => setExpandedVariationGroup(expanded ? grupo.id : false)}
                  >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
                        <Box display="flex" alignItems="center" gap={1}>
                          <Checkbox
                            color="primary"
                            checked={isGroupSelected}
                            onClick={event => event.stopPropagation()}
                            onChange={event => handleToggleGroup(grupo, event.target.checked)}
                          />
                          <Typography>{grupo.nome}</Typography>
                        </Box>
                        <Typography variant="body2" color="textSecondary">
                          {selectedIds.length} selecionada(s)
                        </Typography>
                      </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                      {grupo.opcoes && grupo.opcoes.length ? (
                        <Grid container spacing={1}>
                          {grupo.opcoes.map(opcao => {
                            const optionSelected = selectedIds.includes(opcao.id);
                            return (
                              <Grid item xs={12} sm={6} key={opcao.id}>
                                <Box className={classes.variationOptionRow}>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        color="primary"
                                        checked={optionSelected}
                                        onChange={() => handleToggleVariationOption(grupo.id, opcao.id)}
                                      />
                                    }
                                    label={opcao.nome}
                                  />
                                </Box>
                              </Grid>
                            );
                          })}
                        </Grid>
                      ) : (
                        <Typography variant="body2" color="textSecondary">
                          Nenhuma opção cadastrada.
                        </Typography>
                      )}
                    </AccordionDetails>
                  </Accordion>
                );
              })}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseVariationsModal}>Cancelar</Button>
          <Button
            color="primary"
            variant="contained"
            onClick={handleSaveVariations}
            disabled={saving}
          >
            Salvar
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default ProdutosPage;